import React, { useState, useEffect } from 'react';
import axios from "axios";
import Verifiers from '../../../../utils/Verifiers';
import { PHP_API } from '../../../../utils/Common';
import Post from '../../../../utils/Post';
import VainillaDialogV2 from '../../../../utils/VainillaDialogv2';
import AgregarEntradaPlan from '../../../sharecomponents/AgregarEntradaPlan';
import Formats from './formats';
import ResumenMetasDescarga from './ResumenMetasDescarga';

const VerPlanSiembra = (p) => {
    const [semanas, setsemanas] = useState([]);
    const [flores, setflores] = useState([]);
    const [form, setform] = useState({ florid: '0', semana: '', tipo_semana: 'siembra', flor: '', variedad: '', color: '' });
    const [plan, setplan] = useState([]);
    const [loader, setloader] = useState(false);
    const [editar, seteditar] = useState(-1);
    const [cargaManual, setcargaManual] = useState(false);
    const formatter = new Formats();
    const [dataFromat, setdataFromat] = useState({ ...formatter.plan_table_format_heads() });
    const [resumen, setresumen] = useState(false);
    const [datosOpciones, setdatosOpciones] = useState({ colores: [], variedades: [], flores: [] });
    const keys = [{ key: 'flores', name: 'flor' }, { key: 'variedades', name: 'variedad' }, { key: 'colores', name: 'color' }];
    const [screen, setscreen] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [dialog, setdialog] = useState({ show: false });
    var counter = 0;

    useEffect(() => {
        if (counter > 0) return;
        counter++;
        initialData();
        Verifiers.onScreenResize(setscreen);
    }, []);

    const handleChange = (e) => {
        let f = { ...form };
        if (['semana', 'siembra'].includes(e.target.name)) f.florid = "0";
        f[e.target.name] = e.target.value;
        getPlanSimebra(f);
        setform(f);
    }

    const getPlanSimebra = async (formm = { ...form }) => {
        if (formm.semana === "" && formm.florid === "0") return;
        let resp = await Post("api/getPlanSiembraSemana", formm, 'POST', setloader);
        if (!resp.estatus) return;
        setplan(resp.data.resultados);
        setflores(resp.data.flores ?? []);
        setsemanas(resp.data.semanas ?? []);
        setdatosOpciones({ colores: resp.data.colores ?? [], variedades: resp.data.variedades ?? [], flores: resp.data.flores ?? [] });
    }

    const guardarCambiosEntrada = async (datos) => {
        let resp = await Verifiers.getDataAPI('/api/editarEntradaPlan', datos, setloader, setdialog);
        if (!resp?.estatus) return;
        if (datos.tipo == 3) setcargaManual(false);
        initialData();
        getPlanSimebra(form);
        Verifiers.activeDialog(setdialog, resp.msj, 'Registro actualizado', 'success');
        setcargaManual(false);
    }

    const initialData = async () => {
        let resp = await Post("api/genPlanesData", {}, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(resp.msj);
            return;
        }
        setsemanas(resp.data.semanas);
        setflores(resp.data.flores);
    }

    const canEdit = (data) => {
        if (data.lunes_plan > 0 || data.martes_plan > 0 || data.miercoles_plan > 0 || data.jueves_plan > 0 || data.viernes_plan > 0 || data.sabado_plan > 0) return false;
        return true;
    }

    const activeDialog = (info, type = "error", head = "Ocurrió un problema") => {
        setdialog({
            tipo: type,
            show: true,
            title: head,
            body: info ?? "",
            funct: () => { setdialog({ show: false }) },
            size: 'm'
        })

    }

    return (
        <div className='row justify-content-center m-0 p-0'>
            <div className='col-lg-12 text-center p-1 m-0 ' style={{ overflow: 'auto' }}>
                <div className='row justify-content-center m-0 p-0 mt-2'>
                    <div className='form-group bw-200'>
                        <label className="text-bold w-100 text-start">Tipo de semana</label>
                        <select className='form-select form-select-sm' name="tipo_semana" id='selectSemana' value={form.tipo_semana} disabled={form.semana === ''}
                            onChange={handleChange}>
                            <option value={"semanainicio"}>Siembra</option>
                            <option value={"transplante"}>Transplante</option>
                            <option value={"semanaCosecha"}>Cosecha</option>
                        </select>
                    </div>
                    <div className='form-group' style={{ width: '200px' }}>
                        <label className="text-bold w-100 text-start">Semana</label>
                        <select className='form-select form-select-sm' name="semana" id='selectSemana' value={form.semana}
                            onChange={handleChange}>
                            <option value=''>Seleccione</option>
                            {semanas.map((semana, i) => <option value={semana.semana} key={" semana nombre" + i}>{semana.semana}</option>)}
                        </select>
                    </div>

                    {keys.map((d, j) => <div className='form-group bw-200 mt-2' key={"form" + d.key}>
                        <label className="text-bold w-100 text-start">{d.key.toUpperCase()}</label>
                        <select className="form-control form-control-sm"
                            name={d.name} value={form[d.name] ?? 0}
                            onChange={handleChange}
                            disabled={form.semana === ''} >
                            <option value={""}>Todos los resultados</option>
                            {datosOpciones[d.key].map((f, i) =>
                                <option key={i + d.key + d.name} value={f.id ?? ""}>{(f.nombre ?? "").toUpperCase()} </option>)
                            }
                        </select>
                    </div>
                    )}

                    <div className='form-group  bw-200'>
                        <div className='w-100 text-start text-xs text-bold'>Descarga del plan de siembra</div>
                        <button className=' w-100 btn btn-sm btn-light shadow border border-warning border-2 round-m tect-bold' onClick={() => { if (!resumen) setresumen(true); }} >Resumen de metas</button>
                    </div>

                    {(plan && plan.length === 0) && <div className="col-lg-10 text-center text-l pb-2 m-0 p-0">Para consultar el plan de siembra seleccione una <span className='text-bold'>Semana</span> en el botón desplegable superior, puede fitrar los resultados por flor seleccionando el <span className='text-bold'>Tipo de flor</span> al lado del botón desplegable de la semana</div>}
                    <div className="mt-3 w-100" style={{ maxHeight: Verifiers.maxHeight(screen, 700, 1150, 68, .1), overflowY: 'auto' }}>
                        {plan && plan.length > 0 &&
                            <table className="table table-responsive table-sm table-bordered  table-hover text-sm mb-3 w-100">
                                <thead>
                                    <tr className='nowrap' style={{ backgroundColor: '#9c4221', color: 'white' }}>
                                        {
                                            dataFromat.heads.map((head, i) =>
                                                <th key={'hjead' + i} className="text-center p-2">
                                                    {head}
                                                </th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {plan.map((d, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                                {d.datos.map((dt, j) => {
                                                    return (
                                                        <tr key={j} className={`border-2  ${canEdit(dt) ? 'pointer' : ' text-bold'} ${dt.estatus === "TRANSPLANTE" ? 'bg-green-100' : ''}`}
                                                            onClick={() => {//if(!canEdit(dt)) return; 
                                                                let edit = { ...dt };
                                                                edit.fl = dt.flor;
                                                                edit.vr = dt.variedad;
                                                                edit.col = dt.color;
                                                                seteditar(edit); setcargaManual(true);
                                                            }}>
                                                            <td className="text-center bg-yellow-200 text-sm px-2 py-1"> {dt.semanainicio} </td>
                                                            <td className={dt.estatus === "ACLIMATACION"
                                                                ? "border border-orange-200 bg-orange-200 text-orange-900 text-center text-sm px-2 py-1"
                                                                : "border text-center text-sm px-2 py-1"} >{dt.estatus}
                                                            </td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.transplante} </td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.flor}</td>
                                                            <td className="text-center text-sm px-2 py-1 nowrap">{dt.variedad}</td>
                                                            <td className="text-center text-sm px-2 py-1 nowrap">{dt.color}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.densidad}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.propagacion ?? 0}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.campo ?? 0}</td>
                                                            <td className="text-center bg-yellow-200 text-sm px-2 py-1">{dt.semanaCosecha}</td>
                                                            <td className="text-center text-sm px-2 py-1">{new Intl.NumberFormat("en-EN").format(dt.reqm2)}</td>
                                                            <td className="text-center bg-yellow-200 text-sm px-2 py-1">{new Intl.NumberFormat("en-EN").format(dt.plantas)}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.recuperacion} </td>
                                                            <td className="text-center text-sm px-2 py-1">{new Intl.NumberFormat("en-EN").format(dt.cantidadTallos)}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.camas}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.cavidad}</td>
                                                            <td className="text-center text-sm px-2 py-1">{dt.por_germinacion}</td>
                                                            <td className="text-center text-sm px-2 py-1">{new Intl.NumberFormat("en-EN").format(dt.charolas)}</td>
                                                            <td className="text-center text-sm px-2 py-1">{new Intl.NumberFormat("en-EN").format(dt.semillas)}</td>
                                                        </tr>
                                                    );
                                                })}
                                                <tr key={i} className="mb-2 bg-white">
                                                    <td className="text-center text-sm  px-2 py-3 border border-white" colSpan="11" ></td>
                                                    <td className="text-center  border border-white bg-white">
                                                        <div className="col-lg-12  px-2 py-2 bg-orange-200">{new Intl.NumberFormat("en-EN").format(d.totales.plantas)}</div>
                                                        <br></br>
                                                    </td>
                                                    <td className="text-center  bg-white text-sm  px-2 py-3"></td>
                                                    <td className="text-center bg-white">
                                                        <div className="col-lg-12  px-2 py-2 bg-orange-200">{new Intl.NumberFormat("en-EN").format(d.totales.tallos_cos)}</div>
                                                        <br></br>
                                                    </td>
                                                    <td className="text-center bg-white text-sm  px-2 py-3" colSpan="3"></td>
                                                    <td className="text-center">
                                                        <div className="col-lg-12  px-2 py-2 bg-orange-200">{new Intl.NumberFormat("en-EN").format(d.totales.charolas)}</div>
                                                        <br></br>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="col-lg-12  px-2 py-2 bg-orange-200">{new Intl.NumberFormat("en-EN").format(d.totales.semillas)}</div>
                                                        <br></br>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>}
                    </div>
                </div>
            </div>
            {cargaManual && <AgregarEntradaPlan elemento={editar} cerrar={() => { setcargaManual(false) }} actualizar={guardarCambiosEntrada} canEdit={canEdit} />}
            {resumen && <ResumenMetasDescarga close={() => { setresumen(false) }} />}
            <VainillaDialogV2 data={dialog} />
        </div>

    )
}

export default VerPlanSiembra;